import { parseURI } from '@cian/http-api';
import { IFilters } from '../../types/filters';

interface IParams {
  filters?: IFilters;
  page?: number;
}

export function transformFiltersToQueryString({ filters, page }: IParams) {
  const url = parseURI(window.location.href);
  const query = new URLSearchParams(url.query);

  if (page && page !== 1) {
    query.set('page', String(page));
  } else {
    query.delete('page');
  }

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      const isEmptyArray = Array.isArray(value) && !value.length;
      const isEmptyValue = !value;

      if (isEmptyValue || isEmptyArray) {
        query.delete(key);
      } else {
        query.set(key, String(value));
      }
    });
  }

  return query.toString();
}
